import { Fade } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import React from 'react';
import { ReactComponent as PageLoader } from './pageLoading.svg';

const ScreenLoading = () => (
  <div>
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open>
      <Fade in>
        <PageLoader />
      </Fade>
    </Backdrop>
  </div>
);

export default ScreenLoading;
